import type {
  ArtifactPreviewSummary,
  ClientArtifactPreviewContribution,
} from '../../../../client/src/modules/registry.js';

function getCustomType(metadata: ArtifactPreviewSummary['metadata']): string | null {
  const custom = metadata?.custom;
  if (!custom || typeof custom !== 'object' || Array.isArray(custom)) return null;
  const directType = custom['type'];
  if (typeof directType === 'string') return directType;
  const nestedCustom = custom['custom'];
  if (!nestedCustom || typeof nestedCustom !== 'object' || Array.isArray(nestedCustom)) return null;
  const nestedType = (nestedCustom as Record<string, unknown>)['type'];
  return typeof nestedType === 'string' ? nestedType : null;
}

export const financeArtifactPreviewContribution: ClientArtifactPreviewContribution = {
  id: 'finance.conversation-artifact-preview',
  label: 'Preview',
  matches: (artifact) =>
    artifact.kind === 'custom' && (getCustomType(artifact.metadata)?.startsWith('finance.') ?? false),
  lazy: () =>
    import('./FinanceArtifactPreviewView.js').then((module) => ({ default: module.FinanceArtifactPreviewView })),
};
